import './styles/App.scss';

import { Divider } from 'antd';
import * as React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import ScrollToTop from 'src/components/ScrollTop';

import RouteFallback from './components/RouteFallback';
import BlankLayout from './layouts/BlankLayout';
import HomeLayout from './layouts/HomeLayout';
import NormalLayout from './layouts/NormalLayout';

class App extends React.Component {
  public render() {
    return (
      <BrowserRouter>
        <ScrollToTop>
          <Divider orientation='left' style={{ display: 'none' }} />
          <Switch>
            <Route path='/home' component={HomeLayout} />
            <Route path='/blank' component={BlankLayout} />
            <Route path='/normal' component={NormalLayout} />
            <Route component={RouteFallback} />
          </Switch>
        </ScrollToTop>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx